export default {
  SET_PAYMENT_INVOICES(state, invoices) {
    state.invoices = invoices;
  },
  ADD_TRANSACTION(state, transaction) {
    state.transaction = transaction;
  },
};
